export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_LOGIN_STATE = 'SET_LOGIN_STATE'
export const ROUTE_INCLUDES_REMOVE = 'ROUTE_INCLUDES_REMOVE'